import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

interface PdfStatusEntry {
  status: "pending" | "ready";
  startedAt: number;
  lastUpdatedAt: number;
}

interface PdfStatusState {
  [path: string]: PdfStatusEntry;
}

const initialState: PdfStatusState = {};

const pdfStatusSlice = createSlice({
  name: "pdfStatus",
  initialState,
  reducers: {
    setPdfStatus: (
      state,
      action: PayloadAction<{ path: string; status: "pending" | "ready" }>
    ) => {
      const now = Date.now();
      if (!state[action.payload.path]) {
        state[action.payload.path] = {
          status: action.payload.status,
          startedAt: now,
          lastUpdatedAt: now,
        };
      } else {
        state[action.payload.path].status = action.payload.status;
        state[action.payload.path].lastUpdatedAt = now;
        if (action.payload.status === "pending") {
          state[action.payload.path].startedAt = now;
        }
      }
    },
  },
   extraReducers: (builder) => {
      builder.addCase(PURGE, () => initialState); // THIS LINE
    },
});

export const { setPdfStatus } = pdfStatusSlice.actions;
export default pdfStatusSlice.reducer;
